import { tokens } from '@welbe/web-design-system';
import styled from 'styled-components';

export const Header = styled.div`
	display: flex;
	align-items: center;
	justify-content: space-between;
	margin: 30px 20px;

	> div {
		display: flex;
		align-items: center;
	}
`;

export const Icon = styled.img`
	width: 30px;
	height: 30px;
`;

export const Title = styled.span`
	font-style: normal;
	font-weight: 500;
	font-size: 24px;
	line-height: 24px;
	color: ${tokens.color_gray_dark};

	padding-left: 20px;
`;

export const ButtonContainer = styled.div`
	display: flex;
	align-items: end;

	button:nth-child(1) {
		margin-right: 10px;
	}
`;
